<template>
  <div class="task-question question-review">
    <question-review>
      <!-- 增加一个全程录音 如果开启了全程录音 -->
      <layout-panel :hideCollapse="true" v-if="page.isOpenThroughRecord">
        <template slot="header">
          <span>全程录音</span>
        </template>
        <answer-file-list
            v-if="page.questionContainerElement"
            :question="page.questions[0]"
            :question-index="0"
            :files="page.answers[0].evidences"
            :prepend-files="[]"
            type="record"
            :disabled="disabled"
            :upload-data="{orderid: orderDetail.orderid}"
            :get-lable-data="getLableData"
            :context-menu-container="page.questionContainerElement"
            @change="answerChange"
            :datetime="orderDetail.userfinishtime"/>
      </layout-panel>
      <order-review-question v-for="(question, index) in page.questions"
                             :key="question.id"
                             :question-index="index"
                             :question="question"
                             :answer="page.answers[index]"></order-review-question>
    </question-review>
  </div>
</template>

<script>
import QuestionReview from '@/views/question-review/packages/QuestionReview/src/QuestionReview'
import ContextMenu from '@views/question-review/components/ContextMenu'
import AnswerFileList from '@views/question-review/packages/AnswerFileList'
import '@views/question-review/question-review.scss'
import LayoutPanel from '../../../../../core/components/LayoutPanel.vue'
import OrderReviewQuestion from './OrderReviewQuestion'

export default {
  components: { OrderReviewQuestion, QuestionReview, LayoutPanel, AnswerFileList },
  mixins: [],
  inject: ['page'],
  props: {},
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState({
      orderDetail: state => state.orderReview.orderDetail,
    }),
    ...Vuex.mapGetters('orderReview', [
      'allowModifyAnswer',
      'allowOrderReview',
    ]),
    isRereview () {
      return this.orderDetail.status === '40'
    },
    disabled () {
      return !(this.isRereview || this.allowModifyAnswer)
    },
  },
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {
    this.page.questionContainerElement = this.$el
    ContextMenu({}, true).appendElement(this.$el)
  },
  methods: {
    getLableData (src) {
      return request('findRecognitionResults', {order_id: this.orderDetail.orderid, url: src})
    },
    answerChange () {
      // 修改答案重置审核
      if (this.allowOrderReview) {
        QuestionReview().emptyReviewed(this.page.questions[0].id)
      }
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.task-question {
  width: 100%;
  /*overflow: hidden;*/
  height: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/pages/OrderReviewQuestionPanel/index.vue